import PropTypes from 'prop-types';
import Spinner from '~/js/components/general/Spinner';
import EventItem from '~/js/components/liv-plus/EventItem';
import categoriesData from '~/js/components/liv-plus/data/categories';

const { PureComponent } = React;

class MainView extends PureComponent {
  constructor(props) {
    super(props);

    this.footerRef = React.createRef();

    props.setDefaultSection();
  }

  componentDidMount() {
    this.props.initialTopScroll();
  }

  categoryBlock({ type, description, img, logo }) {
    const { events } = this.props;
    const classes = ['category-row', 'row', 'end-xs'];

    if (!events.length) {
      classes.push('no-events');
    }

    return (
      <div className={classes.join(' ')}>
        <div className="hexagon" />
        <div className={`xs-12 xl-10 category-block ${type}`}>

          <div className="category-content">
            <div className="category-logo">
              <img src={logo} alt={type}/>
            </div>
            <p>{description}</p>
          </div>
        </div>
      </div>
    );
  }

  scrollToRef = (ref, offSet) => () => {
    if (ref) {
      $('body, html').animate({
        scrollTop: ref.current.offsetTop + offSet
      }, 500);
    }
  }

  render() {
    const { events, tabChecked, loading, learMoreHandler, tabHandler } = this.props;
    const { cdn_url: cdnURL } = window.beaches_app.global;

    let eventsView = <Spinner />;

    if (!loading) {
      if (events.length) {
        eventsView = events.map((event, index) => (
          <EventItem
            key={index}
            eventId = {event.eventId}
            type={event.groupName.toLowerCase()}
            eventName={event.eventName}
            eventDate={event.livPlusEventDateWithoutHtml}
            eventRstCode={event.rstCode}
            eventResorts={event.resortCodeList}
            customRstInfo={event.customRstInfo}
            resortInfoPlaceholder={event.resortInfo}
            groupName={event.groupName}
            images={event.mainImages}
            mediaId={event.mediaId}
            description={event.descriptionWithoutHtml}
            externalLink={event.landingPageUrl}
            onLearMore={() => learMoreHandler(event)} />
        ));
      } else if (tabChecked) {
        eventsView = (
          <div className={`coming-soon ${tabChecked.type}`}>
            <span>
              Upcoming {tabChecked.caption} Events <strong>Coming Soon</strong>
            </span>
          </div>
        );
      } else {
        eventsView = <div className="no-results">Currently, there are no events</div>;
      }
    }

    return(
      <div className="main-view">
        <div className="pages-header">
          <div className="header-content xs-12">
            <h1>Special Events</h1>
            <h2>Seek More In a Vacation Than Just a Destination</h2>
            <p>Now, you can enjoy Beaches incredible inclusions, plus indulge in special events and experiences centered around music, culture, sports, culinary, voluntourism, and social interest.</p>
          </div>
        </div>

        <div className="container">
         
          <div className="container">
            {tabChecked && this.categoryBlock(tabChecked)}
          </div>

          {eventsView}
        </div>
        
      </div>
    );
  }
}

MainView.propTypes = {
  events: PropTypes.array,
  tabChecked: PropTypes.object,
  learMoreHandler: PropTypes.func,
  tabHandler: PropTypes.func,
  initialTopScroll: PropTypes.func,
  setDefaultSection: PropTypes.func,
};

MainView.defaultProps = {
  events: [],
  learMoreHandler: () => {},
  tabHandler: () => {},
  initialTopScroll: () => {},
  setDefaultSection: () => {}
};

export default MainView;
